import { createSlice } from '@reduxjs/toolkit';


const values = [
    {
        "formType": 'Gistology',
        "idetifier":[
            "description",
            "cassets",
            "archive",
            "calcium",
            "doc",
            "laborant"
        ],
        "title": 'Гістологія',
        "dataType": 'laborant',
        "fields": [
            {
                "legend": 'Макроскоповий опис',
                "id":1,
                "type": 'textarea',
                "required": true,
                "name": 'description',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Кількість касет',
                "id":2,
                "type": 'text',
                "required": true,
                "name": 'cassetsAfter',
                "options": false,
                "props": []
            },
            {
                "legend": 'Наявність архіву',
                "id":3,
                "type": 'radio',
                "required": true,
                "name": 'archive',
                "options": false,
                "props": [
                    {
                    "label": 'Так',
                    "id":661,
                    "type": 'radio'
                    },
                    {
                    "label": 'Ні',
                    "id":662,
                    "type": 'radio'
                    },
                ] 
            },
            {
                "legend": 'Декальцінація',
                "id":4,
                "type": 'radio',
                "required": true,
                "name": 'calcium',
                "options": false,
                "props": [
                    {
                    "label": 'Так',
                    "id":661,
                    "type": 'radio'
                    },
                    {
                    "label": 'Ні',
                    "id":662,
                    "type": 'radio'
                    },
                ] 
            },
            {
                "legend": 'Лікар',
                "id":5,
                "type": 'text',
                "required": true,
                "name": 'doc',
                "options": true,
                "props": []
            },
            {
                "legend": 'Лаборант',
                "id":5,
                "type": 'text',
                "required": true,
                "name": 'laborant',
                "options": true,
                "props": []
            },
        ],
        "button": "Сформувати",
        "class": 'form__box__register'
    },{
        "formType": 'Express',
        "idetifier":[
            "description",
            "doc",
            "laborant"
        ],
        "title": 'Експрес',
        "dataType": 'laborant',
        "fields": [
            {
                "legend": 'Макроскоповий опис',
                "id":1,
                "type": 'textarea',
                "required": true,
                "name": 'description',
                "options": false,
                "props": [
                    {
                    "label": '',
                    "id":881,
                    "type": 'text',
                    "placeholder": 'Введіть дані...'
                    },
                ] 
            },
            {
                "legend": 'Лікар',
                "id":5,
                "type": 'text',
                "required": true,
                "name": 'doc',
                "options": true,
                "props": []
            },
            {
                "legend": 'Лаборант',
                "id":5,
                "type": 'text',
                "required": true,
                "name": 'laborant',
                "options": true,
                "props": []
            },
        ],
        "button": "Сформувати",
        "class": 'form__box__register'
    }
]

const labFormSlice = createSlice({
    name:'labForm',
    initialState: values,
    reducers: {
        labFormCreation: (state, action) => {
            state.push(action.payload)
        },
        cassetsFormCreation: (state, action) => {
            state[0].fields.map(el=>{
                if(el.name === 'cassetsAfter'){
                    let arr = []
                    for(let i = 1; i <= action.payload; i++){
                        arr.push({
                            "register": "cassets" + i,
                            "label": i,
                            "id":771 + i,
                            "type": 'text',
                            "placeholder": 'Введіть опис'
                        })
                    }
                    el.props = arr
                }
            }) 
        },
        dryCreation: (state, action) => {
            state[0].fields.map(el=>{
                console.log(el)
                if(el.name === 'cassetsAfter'){
                    for (let i = 1; i <= action.payload; i++){
                        el.props.push({
                            "register": "cassets" + (+(el.props.length)+i),
                            "label": +(el.props.length)+i,
                            "id":771 + (+(el.props.length)+i),
                            "type": 'text',
                            "placeholder": 'Введіть опис'
                        })
                    }
                }
            }) 
        }
    }
})

export const { labFormCreation, cassetsFormCreation, dryCreation } = labFormSlice.actions;
export default labFormSlice;